import { render, staticRenderFns } from "./PageFinished.vue?vue&type=template&id=3312d043&scoped=true&"
import script from "./PageFinished.vue?vue&type=script&lang=js&"
export * from "./PageFinished.vue?vue&type=script&lang=js&"
import style0 from "./PageFinished.vue?vue&type=style&index=0&id=3312d043&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3312d043",
  null
  
)

export default component.exports